import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberOutlined = _resolveComponent("NumberOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_TransactionOutlined = _resolveComponent("TransactionOutlined")!
  const _component_AimOutlined = _resolveComponent("AimOutlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        breakpoint: "lg",
        "collapsed-width": "0",
        collapsed: _ctx.isCollapsed,
        "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCollapsed) = $event)),
        onBreakpoint: _ctx.onBreakpoint,
        style: _normalizeStyle({ backgroundColor: 'transparent', position: (_ctx.isBroken) ? 'absolute' : 'relative', zIndex: 1, }),
        width: "300px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "inline",
            openKeys: ['admin', 'account', 'chargeCoin', 'tlbb'],
            selectedKeys: [ (_ctx.curRouteName as string) ],
            theme: "dark"
          }, {
            default: _withCtx(() => [
              (_ctx.hasModeratorPermission)
                ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "admin" }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_NumberOutlined)
                    ]),
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('text.administrator')), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: _ctx.RouteName.ARTICLE_LIST
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: { name: _ctx.RouteName.ARTICLE_LIST }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('text.menuAdminArticle')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _: 1
                      })),
                      (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: _ctx.RouteName.GIFTCODE_MANAGE
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: { name: _ctx.RouteName.GIFTCODE_MANAGE }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('text.menuAdminGiftCode')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _: 1
                      })),
                      (_ctx.hasManagerPermission)
                        ? (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: _ctx.RouteName.COIN_CHARGE_MANAGE
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: { name: _ctx.RouteName.COIN_CHARGE_MANAGE }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('text.menuAdminChargeCoin')), 1)
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.hasManagerPermission)
                        ? (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: _ctx.RouteName.USER_LIST_MANAGER
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: { name: _ctx.RouteName.USER_LIST_MANAGER }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('text.menuAdminMangeUser')), 1)
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.hasManagerPermission)
                        ? (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: _ctx.RouteName.BILLING_PC_LOGGED_IN_GAME_MANAGE
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: { name: _ctx.RouteName.BILLING_PC_LOGGED_IN_GAME_MANAGE }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('text.menuAdminPcLoginPermission')), 1)
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.hasMasterAdminPermission)
                        ? (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: _ctx.RouteName.SITE_CONFIGURATION
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: { name: _ctx.RouteName.SITE_CONFIGURATION }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('text.menuAdminSiteConfig')), 1)
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_sub_menu, { key: "account" }, {
                icon: _withCtx(() => [
                  _createVNode(_component_UserOutlined)
                ]),
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('text.account')), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: _ctx.RouteName.TOP
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: { name: _ctx.RouteName.TOP }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.menuAccountManager')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              }),
              _createVNode(_component_a_sub_menu, { key: "chargeCoin" }, {
                icon: _withCtx(() => [
                  _createVNode(_component_TransactionOutlined)
                ]),
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('text.chargeCoin')), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: _ctx.RouteName.PAYMENT_CHARGE_VIA_CRYPT_COIN
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: { name: _ctx.RouteName.PAYMENT_CHARGE_VIA_CRYPT_COIN }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.menuPaymentChargeUseCryptCoin')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  })),
                  (_ctx.hasManagerPermission)
                    ? (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: _ctx.RouteName.PAYMENT_CHARGE_VIA_EBANK
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: { name: _ctx.RouteName.PAYMENT_CHARGE_VIA_EBANK }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('text.menuPaymentChargeUseBankTransfer')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: _ctx.RouteName.PAYMENT_CHARGE_VIA_CARD
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: { name: _ctx.RouteName.PAYMENT_CHARGE_VIA_CARD }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.menuPaymentChargeUseCard')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  })),
                  (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: _ctx.RouteName.PAYMENT_HISTORY
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: { name: _ctx.RouteName.PAYMENT_HISTORY }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.menuPaymentHistory')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              }),
              _createVNode(_component_a_sub_menu, { key: "tlbb" }, {
                icon: _withCtx(() => [
                  _createVNode(_component_AimOutlined)
                ]),
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('text.tlbb')), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: _ctx.RouteName.PAYMENT_TRANSFER_TO_TLBB
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: { name: _ctx.RouteName.PAYMENT_TRANSFER_TO_TLBB }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.menuTlbbTransferCoinToGame')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  })),
                  (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: _ctx.RouteName.CHAR_GAME_FUNC
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: { name: _ctx.RouteName.CHAR_GAME_FUNC }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.menuTlbbCharFunc')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["selectedKeys"])
        ]),
        _: 1
      }, 8, ["collapsed", "onBreakpoint", "style"]),
      _createVNode(_component_a_layout_content, {
        style: _normalizeStyle({ paddingLeft: (!_ctx.isCollapsed && !_ctx.isBroken) ? '10px' : '0' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}